import SvgIcon from '@home/components/SvgIcon';
import BubbleCommon, { aigcPromptTips } from '@op/components/BubbleCommon';
import React, { useEffect, useMemo, useState } from 'react';
import { Form, TextArea } from 'tea-component';
import { useIntl } from 'umi';
import { PromptType } from '../../types';
import { getPromptText } from '../../utils';
import { DBO_T } from '@op/utils/format';

export default function CommonForm({
  errorText,
  prompt,
  setErrorText,
  setPrompt,
  promptList,
  defaultActive = 1,
  openHistorical, // 打开历史记录
  isPreview = false,
}: {
  errorText: string;
  prompt: string;
  setErrorText: (text: string) => void;
  setPrompt: (text: string) => void;
  promptList: Array<PromptType>;
  defaultActive: number;
  openHistorical: () => void;
  isPreview?: boolean;
}) {
  const { formatMessage } = useIntl();
  const [active, setActive] = useState(defaultActive);

  const isEmpty = useMemo(() => prompt.trim(), [prompt]);

  function copyPrompt() {
    if (isEmpty) DBO_T.copyText(prompt, formatMessage);
  }

  useEffect(() => {
    const item = promptList.find(
      (item: PromptType) => getPromptText(item) === prompt,
    );
    setErrorText(prompt.trim() ? '' : formatMessage({ id: 'Please enter prompt.' }),);
    setActive(item?.value || -1);
  }, [prompt, promptList]);

  return (
    <Form.Item
      status={errorText ? 'error' : undefined}
      showStatusIcon={false}
      message={errorText}
      className="dbo-prompt-form-item"
      label={
        <div className="item-label">
          {formatMessage({ id: 'Prompt' })}
          {!isPreview && (
            <>
              <span style={{ color: '#ef5858', marginLeft: 5 }}>*</span>
              <BubbleCommon
                tipsMap={aigcPromptTips}
                placement="top"
              ></BubbleCommon>{' '}
            </>
          )}
        </div>
      }
    >
      {isPreview ? (
        <div className="dbo-aigc-modal-textarea --is-preview">{prompt}</div>
      ) : (
        <>
          <TextArea
            className="dbo-aigc-modal-textarea"
            value={prompt}
            onChange={(value) => {
              setPrompt(value);
            }}
          />
          <div className="dbo-aigc-modal-exit">
            {/* disabled 类名 disabled */}
            <div className="dbo-aigc-modal-exit-left">
              {formatMessage({ id: 'Default prompt' })}:
              {promptList.map((item) => {
                return (
                  <div
                    key={item.value}
                    className={
                      item.value === active
                        ? 'dbo-aigc-modal-exit-actiontab'
                        : 'dbo-aigc-modal-exit-tab'
                    }
                    onClick={() => {
                      setPrompt(getPromptText(item));
                      setActive(item.value);
                    }}
                  >
                    {item.value}
                  </div>
                );
              })}
            </div>
            <div className="dbo-aigc-modal-exit-right">
              <div
                className={`dbo-aigc-modal-exit-item ${!isEmpty ? 'disabled' : ''}`}
                onClick={openHistorical}
              >
                <SvgIcon type="clock" className="dbo-aigc-modal-exit-icon" />
                {formatMessage({ id: 'Historical prompt' })}
              </div>
              <div
                className={`dbo-aigc-modal-exit-item ${!isEmpty ? 'disabled' : ''}`}
                onClick={copyPrompt}
              >
                <SvgIcon
                  type="datalab-copy"
                  className="dbo-aigc-modal-exit-icon"
                />
                {formatMessage({ id: 'Copy' })}
              </div>
            </div>
          </div>
        </>
      )}
    </Form.Item>
  );
}
